import { useMutation } from '@tanstack/react-query';

import { getBookingEndpoint } from 'reservations/base/constants/endpoints';
import { HTTP_STATUS_CODE_402_PAYMENT_REQUIRED } from 'reservations/base/constants/httpStatusCodes';
import { useQueryParams } from 'reservations/base/hooks/useQueryParams';
import {
  type BookingMutationResponse,
  BookingMutationResponseSchema
} from 'reservations/booking/types';
import type { BookingFormSchema } from 'reservations/form/components/Form';
import { cleanChecklessFormData } from 'reservations/form/helpers/cleanBookingFormData';
import { restClient } from 'utility/restClient';
import type { RequestError } from 'utility/restClient';

export const useEnrollChecklessMutation = (
  handleSuccess: () => void,
  handleFailure: () => void
) => {
  const { visitId } = useQueryParams();

  return useMutation<
    BookingMutationResponse,
    RequestError,
    Record<string, any>
  >({
    mutationKey: ['ENROLL_CHECKLESS'],
    mutationFn: async formData => {
      const cleanedFormData = cleanChecklessFormData(
        formData as BookingFormSchema
      );
      const endpoint = getBookingEndpoint(visitId, 'checkless');

      const response = await restClient.put(endpoint, {
        data: Object.fromEntries(cleanedFormData)
      });

      try {
        return BookingMutationResponseSchema.parse(response);
      } catch (err) {
        throw err;
      }
    },
    onSuccess: _data => {
      handleSuccess();
    },
    onError: error => {
      if (error.code === HTTP_STATUS_CODE_402_PAYMENT_REQUIRED) {
        handleFailure();
        return;
      }
    }
  });
};
